<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-text-field hide-details label="Kode" color="primary" v-model="params.kode.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Kode Mitra" color="primary" v-model="params.kode_mitra.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field hide-details label="Nama Mitra" color="primary" v-model="params.nama_mitra.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-menu v-model="searchDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Tanggal" readonly v-bind="attrs" v-on="on" :value="convertDate(params.date.value)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="searchDate = false" v-model="params.date.value"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12">
							<v-autocomplete hide-details label="Status" color="primary" :items="status" item-text="text" item-value="value" v-model="params.status.value"></v-autocomplete>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cari">
						<v-icon small v-if="false">mdi-magnify</v-icon>
						<span>Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			searchDate: false,
			btnLoadingProses: false,
			status: [
			{ text: 'Menunggu', value: 'menunggu' },
			{ text: 'Sukses', value: 'sukses' },
			{ text: 'Ditolak', value: 'ditolak' },
			],
			params: {
				kode: {
					type:'string',
					field:'transaction_code',
					value:''
				},
				kode_mitra: {
					type:'string',
					field:'transaction_member_network_code',
					value:''
				},
				nama_mitra: {
					type:'string',
					field:'transaction_member_name',
					value:''
				},
				date: {
					type:'string',
					field:'transaction_datetime',
					value:''
				},
				status: {
					type:'string',
					field:'transaction_status',
					value:''
				},
			},
		}
	},
	computed:{

	},
	props: ['isReset'],
	watch: {
    // eslint-disable-next-line no-unused-vars
    isReset: function (newStatus, oldStatus) {
      if(newStatus) this.reset()
    }
  },
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.params.kode.value = ''
			this.params.kode_mitra.value = ''
			this.params.nama_mitra.value = ''
			this.params.date.value = ''
			this.params.status.value = ''
		},
		async cari() {
			this.btnLoadingProses = await true
			await this.$emit('action', this.params)
		},
	}
};
</script>